import React from "react";
import { Box, Flex, Tooltip } from "@chakra-ui/react";
import { NotificationInfo } from "../Tooltip/NotificationInfo";

const NotificationStatus = ({ notifications }: any) => {
  const maxCircles = 5;
  const circleColors: any = {
    SENT: "green",
    ERROR: "red",
    PENDING: "orange",
    DEFAULT: "grey",
  };

  const circles = [];

  notifications.forEach((notification: any) => {
    const color = circleColors[notification.status] || circleColors.DEFAULT;
    circles.push(
        <Tooltip label={<NotificationInfo {...notification}/>} placement='bottom-start'>
      <Box
        key={notification.id}
        bg={color}
        borderRadius="50%"
        w="10px"
        h="10px"
        m="1"
      />
      </Tooltip>
    );
  });

  while (circles.length < maxCircles) {
    circles.push(
      <Box
        key={`default-${circles.length}`}
        bg={circleColors.DEFAULT}
        borderRadius="50%"
        w="10px"
        h="10px"
        m="1"
      />
    );
  }

  return <Flex>{circles}</Flex>;
};

export default NotificationStatus;
